import { components } from 'react-select';
import { Flex } from '@chakra-ui/react';

export const Option = ({ children, data, ...props }) => {
  return (
    <components.Option {...props}>
      <Flex alignItems="center" textTransform="captitalize">
        {children}
      </Flex>
    </components.Option>
  );
};
